import { useEffect, useRef } from 'react';
import { Button } from '../../components/Button';
import { Mark } from '../../components/Mark';
import { Panel } from '../../components/Panel';
import { PublicFrame } from '../../components/Shell';
import { useTenant } from '../../lib/tenant-context';

export default function Offline({
  accessUnverified = false,
  checking = false,
  reviewRequired = false,
  onRetry = () => window.location.reload(),
}: {
  accessUnverified?: boolean;
  checking?: boolean;
  reviewRequired?: boolean;
  onRetry?: () => void;
}) {
  const tenant = useTenant();
  const heading = useRef<HTMLHeadingElement>(null);
  useEffect(() => {
    heading.current?.focus();
  }, []);
  return (
    <PublicFrame>
      <Panel padding="lg">
        <div className="mb-5">
          <Mark name={tenant.name} logoUrl={tenant.logo_url} brandMode={tenant.brand_mode} size={34} />
        </div>
        <h1 ref={heading} tabIndex={-1} className="t-title rail:text-[27px] text-ink">
          {checking
            ? 'Checking academy access…'
            : reviewRequired
              ? 'Review access is required.'
              : accessUnverified
                ? 'Academy access could not be checked.'
                : 'You are offline.'}
        </h1>
        <p className="mt-2 text-inkMuted">
          {reviewRequired
            ? 'Leave this page open so your work is not lost. Enter the review password in a new tab, then come back and select Try again.'
            : 'Connect to the internet and try again. Private pages and field cards are not available offline.'}
        </p>
        <div className="mt-6 flex flex-col gap-2">
          {reviewRequired && (
            <a
              href="/__gate"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex min-h-11 items-center justify-center text-[14px] text-accentText underline underline-offset-4"
            >
              Open review sign-in in a new tab
            </a>
          )}
          <Button variant="secondary" block busy={checking} onClick={onRetry}>
            Try again
          </Button>
        </div>
      </Panel>
    </PublicFrame>
  );
}
